export const brandText = {
  MX: {
    brand_text_1: {
      'zh-CN': '滴滴',
      'en-US': 'DiDi',
      'es-MX': 'DiDi',
      'es-419': 'DiDi',
      'es-CO': 'DiDi',
      'pt-BR': 'DiDi',
      'ja-JP': 'DiDi'
    },
    brand_text_2: {
      'zh-CN': '滴滴外卖',
      'en-US': 'DiDi Store',
      'es-MX': 'DiDi Store',
      'es-419': 'DiDi Store',
      'es-CO': 'DiDi Store',
      'pt-BR': 'DiDi Store',
      'ja-JP': 'DiDiストア管理'
    },
    brand_text_3: {
      'zh-CN': 'DiDi Food',
      'en-US': 'DiDi Food',
      'es-MX': 'DiDi Food',
      'es-419': 'DiDi Food',
      'es-CO': 'DiDi Food',
      'pt-BR': 'DiDi Food',
      'ja-JP': 'DiDi Food'
    }
  },
  DO: {
    brand_text_1: {
      'zh-CN': '滴滴',
      'en-US': 'DiDi',
      'es-MX': 'DiDi',
      'es-419': 'DiDi',
      'es-CO': 'DiDi',
      'pt-BR': 'DiDi',
      'ja-JP': 'DiDi'
    },
    brand_text_2: {
      'zh-CN': '滴滴外卖',
      'en-US': 'DiDi Store',
      'es-MX': 'DiDi Store',
      'es-419': 'DiDi Store',
      'es-CO': 'DiDi Store',
      'pt-BR': 'DiDi Store',
      'ja-JP': 'DiDiストア管理'
    },
    brand_text_3: {
      'zh-CN': 'DiDi Food',
      'en-US': 'DiDi Food',
      'es-MX': 'DiDi Food',
      'es-419': 'DiDi Food',
      'es-CO': 'DiDi Food',
      'pt-BR': 'DiDi Food',
      'ja-JP': 'DiDi Food'
    }
  },
  CL: {
    brand_text_1: {
      'zh-CN': '滴滴',
      'en-US': 'DiDi',
      'es-MX': 'DiDi',
      'es-419': 'DiDi',
      'es-CO': 'DiDi',
      'pt-BR': 'DiDi',
      'ja-JP': 'DiDi'
    },
    brand_text_2: {
      'zh-CN': '滴滴外卖',
      'en-US': 'DiDi Store',
      'es-MX': 'DiDi Store',
      'es-419': 'DiDi Store',
      'es-CO': 'DiDi Store',
      'pt-BR': 'DiDi Store',
      'ja-JP': 'DiDiストア管理'
    },
    brand_text_3: {
      'zh-CN': 'DiDi Food',
      'en-US': 'DiDi Food',
      'es-MX': 'DiDi Food',
      'es-419': 'DiDi Food',
      'es-CO': 'DiDi Food',
      'pt-BR': 'DiDi Food',
      'ja-JP': 'DiDi Food'
    }
  },
  CR: {
    brand_text_1: {
      'zh-CN': '滴滴',
      'en-US': 'DiDi',
      'es-MX': 'DiDi',
      'es-419': 'DiDi',
      'es-CO': 'DiDi',
      'pt-BR': 'DiDi',
      'ja-JP': 'DiDi'
    },
    brand_text_2: {
      'zh-CN': '滴滴外卖',
      'en-US': 'DiDi Store',
      'es-MX': 'DiDi Store',
      'es-419': 'DiDi Store',
      'es-CO': 'DiDi Store',
      'pt-BR': 'DiDi Store',
      'ja-JP': 'DiDiストア管理'
    },
    brand_text_3: {
      'zh-CN': 'DiDi Food',
      'en-US': 'DiDi Food',
      'es-MX': 'DiDi Food',
      'es-419': 'DiDi Food',
      'es-CO': 'DiDi Food',
      'pt-BR': 'DiDi Food',
      'ja-JP': 'DiDi Food'
    }
  },
  PE: {
    brand_text_1: {
      'zh-CN': '滴滴',
      'en-US': 'DiDi',
      'es-MX': 'DiDi',
      'es-419': 'DiDi',
      'es-CO': 'DiDi',
      'pt-BR': 'DiDi',
      'ja-JP': 'DiDi'
    },
    brand_text_2: {
      'zh-CN': '滴滴外卖',
      'en-US': 'DiDi Store',
      'es-MX': 'DiDi Store',
      'es-419': 'DiDi Store',
      'es-CO': 'DiDi Store',
      'pt-BR': 'DiDi Store',
      'ja-JP': 'DiDiストア管理'
    },
    brand_text_3: {
      'zh-CN': 'DiDi Food',
      'en-US': 'DiDi Food',
      'es-MX': 'DiDi Food',
      'es-419': 'DiDi Food',
      'es-CO': 'DiDi Food',
      'pt-BR': 'DiDi Food',
      'ja-JP': 'DiDi Food'
    }
  },
  CO: {
    brand_text_1: {
      'zh-CN': '滴滴',
      'en-US': 'DiDi',
      'es-MX': 'DiDi',
      'es-419': 'DiDi',
      'es-CO': 'DiDi',
      'pt-BR': 'DiDi',
      'ja-JP': 'DiDi'
    },
    brand_text_2: {
      'zh-CN': '滴滴外卖',
      'en-US': 'DiDi Store',
      'es-MX': 'DiDi Store',
      'es-419': 'DiDi Store',
      'es-CO': 'DiDi Store',
      'pt-BR': 'DiDi Store',
      'ja-JP': 'DiDiストア管理'
    },
    brand_text_3: {
      'zh-CN': 'DiDi Food',
      'en-US': 'DiDi Food',
      'es-MX': 'DiDi Food',
      'es-419': 'DiDi Food',
      'es-CO': 'DiDi Food',
      'pt-BR': 'DiDi Food',
      'ja-JP': 'DiDi Food'
    }
  },
  JP: {
    brand_text_1: {
      'zh-CN': '滴滴',
      'en-US': 'DiDi',
      'es-MX': 'DiDi',
      'es-419': 'DiDi',
      'es-CO': 'DiDi',
      'pt-BR': 'DiDi',
      'ja-JP': 'DiDi'
    },
    brand_text_2: {
      'zh-CN': '滴滴外卖',
      'en-US': 'DiDi Store',
      'es-MX': 'DiDi Store',
      'es-419': 'DiDi Store',
      'es-CO': 'DiDi Store',
      'pt-BR': 'DiDi Store',
      'ja-JP': 'DiDiストア管理'
    },
    brand_text_3: {
      'zh-CN': 'DiDi Food',
      'en-US': 'DiDi Food',
      'es-MX': 'DiDi Food',
      'es-419': 'DiDi Food',
      'es-CO': 'DiDi Food',
      'pt-BR': 'DiDi Food',
      'ja-JP': 'DiDi Food'
    }
  },
  BR: {
    brand_text_1: {
      'zh-CN': '99',
      'en-US': '99',
      'es-MX': '99',
      'es-419': '99',
      'es-CO': '99',
      'pt-BR': '99',
      'ja-JP': '99'
    },
    brand_text_2: {
      'zh-CN': '99外卖',
      'en-US': '99 Store',
      'es-MX': '99 Store',
      'es-419': '99 Store',
      'es-CO': '99 Store',
      'pt-BR': '99 Store',
      'ja-JP': '99 Store'
    },
    brand_text_3: {
      'zh-CN': '99 Food',
      'en-US': '99 Food',
      'es-MX': '99 Food',
      'es-419': '99 Food',
      'es-CO': '99 Food',
      'pt-BR': '99 Food',
      'ja-JP': '99 Food'
    }
  }
}
